import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SetupState {
    finished: boolean;
    currentStep?: string;
}

const initialState: SetupState = {
    finished: false,
    currentStep: 'client'
};

export const setupSlice = createSlice({
    name: 'setup',
    initialState,
    reducers: {
        setupChange(state, action: PayloadAction<{ finished: boolean }>) {
            state.finished = action.payload.finished;
        },
        stepChange(state, action: PayloadAction<{ currentStep?: string }>) {
            state.currentStep = action.payload.currentStep;
        },
    },
});
export const { setupChange, stepChange } = setupSlice.actions;

export default setupSlice.reducer;